document.addEventListener('DOMContentLoaded', function() {
    const indywidualneSection = document.querySelector('.indywidualne.hero-section');
    const firmySection = document.querySelector('.firmy.hero-section');
    const heroWrapper = document.querySelector('.hero-container__wrapper');
    const videoContainer = document.querySelector('.hero-container__video');
    const suwak = document.querySelector('.hero-suwak');
    
    if (!indywidualneSection || !firmySection || !heroWrapper || !videoContainer) return;
    
    // Sprawdź szerokość ekranu - działa tylko powyżej 768px
    function isDesktop() {
        return window.innerWidth > 768;
    }
    
    // Funkcja do aktualizacji szerokości before na wideo oraz pozycji suwaka
    function updateVideoBefore() {
        // Sprawdź czy jesteśmy na desktop - jeśli nie, nie rób nic
        if (!isDesktop()) {
            videoContainer.style.setProperty('--before-width', '50%');
        if (suwak) suwak.style.left = '50%';
            return;
        }
        
        // Domyślna szerokość - 50%
        let beforeWidth = '50%';
    let dividerLeft = '50%';
        
        // Sprawdź, czy mysz jest nad wrapperem (co oznacza, że hover jest aktywny)
        if (heroWrapper.matches(':hover')) {
            // Sprawdź, która sekcja ma hover
            if (indywidualneSection.matches(':hover')) {
                beforeWidth = '95%';
        dividerLeft = '95%';
            } else if (firmySection.matches(':hover')) {
                beforeWidth = '5%';
        dividerLeft = '5%';
            }
        }
        
        // Ustaw styl inline dla before (używając zmiennej CSS)
        videoContainer.style.setProperty('--before-width', beforeWidth);
    // Przesuń suwak na krawędź między sekcjami
    if (suwak) suwak.style.left = dividerLeft;
    }
    
    // Nasłuchuj na zdarzenia hover na różnych elementach - tylko na desktop
    function attachEventListeners() {
        if (isDesktop()) {
            heroWrapper.addEventListener('mouseenter', updateVideoBefore);
            heroWrapper.addEventListener('mouseleave', updateVideoBefore);
            indywidualneSection.addEventListener('mouseenter', updateVideoBefore);
            firmySection.addEventListener('mouseenter', updateVideoBefore);
            heroWrapper.addEventListener('mousemove', updateVideoBefore);
        }
    }
    
    // Nasłuchuj na zmiany rozmiaru okna
    function handleResize() {
        // Resetuj do domyślnej szerokości przy zmianie rozmiaru
        updateVideoBefore();
    }
    
    // Inicjalizuj event listenery
    attachEventListeners();
    
    // Nasłuchuj na resize
    window.addEventListener('resize', handleResize);

    // Ustaw stan początkowy
    updateVideoBefore();
});